import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-projection-legend",
  "use": "svg-icon-projection-legend-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg-icon-projection-legend\"><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"svg-icon-projection-legend_a\" fill=\"#D99C00\"><path d=\"M10.515 14H14V0H.06v14h10.455z\" /></mask><path d=\"M.06 14H14.1V-.04H.06V14z\" fill=\"#FFEEBA\" mask=\"url(#svg-icon-projection-legend_a)\" /><image width=\"14\" height=\"14\" fill=\"#FFEEBA\"></image></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol